import * as React from 'react';
import cx from 'classnames';
import RCNotification from 'rc-notification';
import createUseMessage from './hooks/useMessage';
import Icon from '../icon';
var TYPE_TO_ICON = {
  message: 'notice-solid',
  success: 'success-s',
  warning: 'notice-circle-s',
  error: 'round-close-s'
};
var messageInstance;
var defaultDuration = 3;
var defaultTop;
var key = 1;
var localPrefixCls = 'shopee-react-toast';
var transitionName = 'move-up';
var getContainer;
var maxCount;
var maxWidth = 600;
var minWidth = 160;
export function getKeyThenIncreaseKey() {
  key += 1;
  return key;
}

function setMessageConfig(options) {
  if (options.top !== undefined) {
    defaultTop = options.top;
    messageInstance = null; // delete messageInstance for new defaultTop
  }

  if (options.duration !== undefined) {
    defaultDuration = options.duration;
  }

  if (options.prefixCls !== undefined) {
    localPrefixCls = options.prefixCls;
  }

  if (options.getContainer !== undefined) {
    getContainer = options.getContainer;
  }

  if (options.transitionName !== undefined) {
    transitionName = options.transitionName;
    messageInstance = null; // delete messageInstance for new transitionName
  }

  if (options.maxCount !== undefined) {
    maxCount = options.maxCount;
    messageInstance = null;
  }

  if (options.maxWidth !== undefined) {
    maxWidth = options.maxWidth;
  }

  if (options.minWidth !== undefined) {
    minWidth = options.minWidth;
  }
}

function getRCNotificationInstance(args, callback) {
  var prefixCls = args.prefixCls || localPrefixCls;

  if (messageInstance) {
    callback({
      prefixCls: prefixCls,
      instance: messageInstance
    });
    return;
  }

  RCNotification.newInstance({
    prefixCls: prefixCls,
    transitionName: transitionName,
    style: {
      top: defaultTop
    },
    getContainer: getContainer,
    maxCount: maxCount
  }, function (instance) {
    if (messageInstance) {
      callback({
        prefixCls: prefixCls,
        instance: messageInstance
      });
      return;
    }

    messageInstance = instance;
    callback({
      prefixCls: prefixCls,
      instance: instance
    });
  });
}

function getRCNoticeProps(args, prefixCls) {
  var duration = args.duration !== undefined ? args.duration : defaultDuration;
  var iconType = TYPE_TO_ICON[args.type];
  return {
    key: args.key,
    duration: duration,
    style: args.style || {},
    className: args.className,
    content:
    /*#__PURE__*/
    React.createElement("div", {
      className: "".concat(prefixCls, "-body"),
      style: {
        maxWidth: maxWidth,
        minWidth: minWidth
      }
    }, args.icon ||
    /*#__PURE__*/
    React.createElement(Icon, {
      className: cx("".concat(prefixCls, "-icon"), "".concat(prefixCls, "-icon--").concat(args.type)),
      type: iconType
    }),
    /*#__PURE__*/
    React.createElement("span", {
      className: "".concat(prefixCls, "-content")
    }, args.content)),
    onClose: args.onClose,
    onClick: args.onClick
  };
}

function notice(args) {
  var target = args.key || getKeyThenIncreaseKey();
  var closePromise = new Promise(function (resolve) {
    var callback = function callback() {
      if (typeof args.onClose === 'function') {
        args.onClose();
      }

      resolve(true);
    };

    getRCNotificationInstance(args, function (_ref) {
      var prefixCls = _ref.prefixCls,
          instance = _ref.instance;
      instance.notice(getRCNoticeProps(Object.assign(Object.assign({}, args), {
        key: target,
        onClose: callback
      }), prefixCls));
    });
  });

  var result = function result() {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };

  result.then = function (filled, rejected) {
    return closePromise.then(filled, rejected);
  };

  result.promise = closePromise;
  return result;
}

function isArgsProps(content) {
  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
}

var api = {
  open: notice,
  useMessage: createUseMessage(getRCNotificationInstance, getRCNoticeProps),
  config: setMessageConfig,
  destroy: function destroy(messageKey) {
    if (messageInstance) {
      if (messageKey) {
        var _messageInstance = messageInstance,
            removeNotice = _messageInstance.removeNotice;
        removeNotice(messageKey);
      } else {
        var _messageInstance2 = messageInstance,
            destroy = _messageInstance2.destroy;
        destroy();
        messageInstance = null;
      }
    }
  }
};
export function attachTypeApi(originalApi, type) {
  return function (content, duration, onClose) {
    if (isArgsProps(content)) {
      return originalApi.open(Object.assign(Object.assign({}, content), {
        type: type
      }));
    }

    var newOnClose = onClose;
    var newDuration = duration;

    if (typeof duration === 'function') {
      newOnClose = duration;
      newDuration = undefined;
    }

    return originalApi.open({
      content: content,
      duration: newDuration,
      type: type,
      onClose: newOnClose
    });
  };
}
['message', 'success', 'warning', 'error'].forEach(function (type) {
  api[type] = attachTypeApi(api, type);
});
api.warn = api.warning;
export default api;
/** @private test only function. Not work on production */

export var getInstance = function getInstance() {
  return process.env.NODE_ENV === 'test' ? messageInstance : null;
};